import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id DE6FDD30-069D-4377-96D1-9DAC014B6A8F
 * name credit-card-plus
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-plus.svg
 * tags
 * - Banking 
 */
export const CreditCardPlusIcon = createSvgIcon(<><path d="M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 19 13A5.88 5.88 0 0 1 22 13.81V6A2 2 0 0 0 20 4M20 11H4V8H20M20 15V18H23V20H20V23H18V20H15V18H18V15Z" /></>, 'CreditCardPlusIcon');
export default CreditCardPlusIcon